var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurServiceDeliveryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 107,
    viewBox: "0 0 94 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 87.7034,
    width: 125,
    height: 6,
    rx: 3,
    transform: "rotate(-44.5577 0 87.7034)",
    fill: "#CEE5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.54199,
    y: 87.7231,
    width: 99.4878,
    height: 6,
    rx: 3,
    transform: "rotate(-44.5577 9.54199 87.7231)",
    fill: "#FFE2EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 101.803,
    width: 99.4878,
    height: 6,
    rx: 3,
    transform: "rotate(-44.5577 5 101.803)",
    fill: "#FFF3E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2917 63.7917C19.2917 65.6262 20.0205 67.3854 21.3176 68.6826C22.6147 69.9797 24.374 70.7084 26.2084 70.7084C28.0428 70.7084 29.8021 69.9797 31.0992 68.6826C32.3964 67.3854 33.1251 65.6262 33.1251 63.7917M19.2917 63.7917C19.2917 61.9573 20.0205 60.1981 21.3176 58.9009C22.6147 57.6038 24.374 56.8751 26.2084 56.8751C28.0428 56.8751 29.8021 57.6038 31.0992 58.9009C32.3964 60.1981 33.1251 61.9573 33.1251 63.7917M19.2917 63.7917H12.3751V49.9584M33.1251 63.7917H53.8751M53.8751 63.7917C53.8751 65.6262 54.6038 67.3854 55.9009 68.6826C57.1981 69.9797 58.9573 70.7084 60.7918 70.7084C62.6262 70.7084 64.3854 69.9797 65.6826 68.6826C66.9797 67.3854 67.7084 65.6262 67.7084 63.7917M53.8751 63.7917C53.8751 61.9573 54.6038 60.1981 55.9009 58.9009C57.1981 57.6038 58.9573 56.8751 60.7918 56.8751C62.6262 56.8751 64.3854 57.6038 65.6826 58.9009C66.9797 60.1981 67.7084 61.9573 67.7084 63.7917M67.7084 63.7917H74.6251V43.0417M8.91675 22.2917H46.9584V63.7917M74.6251 43.0417H46.9584M74.6251 43.0417L64.2501 25.7501H46.9584M12.3751 36.1251H26.2084",
    stroke: "#5B9CD8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurServiceDeliveryIcon);
export default __webpack_public_path__ + "static/media/our-service-delivery-icon.73fdfe1a6a7ac1798819a67eb3d60aa7.svg";
export { ForwardRef as ReactComponent };